import { render, staticRenderFns } from "./searchFaq.vue?vue&type=template&id=0cd09110&scoped=true&"
import script from "./searchFaq.vue?vue&type=script&lang=js&"
export * from "./searchFaq.vue?vue&type=script&lang=js&"
import style0 from "./searchFaq.vue?vue&type=style&index=0&id=0cd09110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd09110",
  null
  
)

export default component.exports